import z, { ZodType } from 'zod';

export type DeviceResponse = {
	id: number;
	name: string;
	isActive: boolean;
};

export const deviceResponseSchema: ZodType<DeviceResponse> = z.object({
	id: z.number(),
	name: z.string(),
	isActive: z.boolean(),
});
